import React from "react";

import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Footer } from "../../components/Footer/Footer";

function DetailsDesktop({ app, config }) {
  return (
    <div className="app details">
      <div className="appContent">
        <LayoutWrapper>
          <Grid className="container-details">
            <Card
              app={app}
              header={{
                hardTitle: "Detalhamento",
              }}
              exportContainer
              exportTable
              exportTableId="uJkEyW"
              style={{ margin: "0 0 16px" }}
            >
              <NativeObject
                app={app}
                key="uJkEyW"
                reference={{ id: "uJkEyW" }}
                style={{
                  width: "100%",
                  height: "calc(100vh - 240px)",
                }}
              />
            </Card>
          </Grid>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

DetailsDesktop.defaultProps = {
  app: null,
  config: {},
};

DetailsDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetailsDesktop;
